module.exports = __webpack_public_path__ + "img/login2.31f7459b.png";